<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <div class="text-xs-center">
        <v-dialog v-model="dialog2" width="900">
          <v-card>
            <v-card-title class="project">
              <div><span class="headline">Terms & Conditions</span></div>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <terms-and-conditions class="scroll-y"></terms-and-conditions>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" flat @click="dialog2 = false">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-flex xs12 sm6 offset-sm3>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div><span class="headline">Payment Method</span></div>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-2 text-none" small dark @click="back"
                >Back
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Your Total Amount Due:</v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ subscriptionPack.package_price }} Tk
                  </v-subheader>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm6 md12 wrap>
                  <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Terms & Conditions</v-subheader
                  >
                </v-flex>
                  <!-- <div class="mb-2">
                    <h3 class="black--text ml-4">Terms & Conditions</h3>
                  </div> -->
                  <div style="max-height: 300px;" class="scroll-y">
                    <terms-and-conditions
                    ></terms-and-conditions>
                  </div>
                  <v-checkbox
                    v-model="terms_and_conditions"
                    label="I agree to this terms and conditions"
                  ></v-checkbox>
                  <v-spacer></v-spacer>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="black--text title"
                    >Select Your Payment Method</v-subheader
                  >
                </v-flex>
                <v-flex xs12 sm6 md12>
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="cheque"
                    :disabled="clicked || !terms_and_conditions"
                    >Cheque</v-btn
                  >
                  <v-btn
                    class="pay-button text-none"
                    flat
                    @click="paymentGateway"
                    :disabled="clicked || !terms_and_conditions"
                    >Payment Gateway</v-btn
                  >
                </v-flex>
              </v-layout>
              
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../../../router";
import { BkashImageUpload } from "@/components/index";
import { ChequeImageUpload } from "@/components/index";
import { ChequeDepositImage } from "@/components/index";
import { TermsAndConditions } from "@/components/index";

export default {
  data: () => ({
    valid: true,
    dialog: false,
    dialog2: false,
    clicked: false,
    apiUrl: "client-pay",
    editedIndex: -1,
    menu1: false,
    menu2: false,
    date: null,
    time: null,
    total_budget: "",
    perSurveyCost: "",
    payment_method_id: null,
    terms_and_conditions: false,
    subscriptionPack: {},
    editedItem: {
      package_id: "",
      duration: "",
      paid_amount: "",
    },
    defaultItem: {
      project_id: "",
      transaction_id: "",
      paid_amount: "",
      beftn_routing_number: "",
      trasanction_date: "",
      trasanction_time: "",
      transaction_photo: "",
      payment_method_id: "",
      payment_status_id: "",
      account_name: "",
      bank_name: "",
      account_number: "",
      cheque_receive_date: "",
      cheque_deposit_date: "",
      cheque_photo: "",
      deposit_slip_photo: "",
    },
    budget: {
      total_budget_amount: "",
      total_budget_coins: "",
      per_survey_cost_coins: "",
      project_id: "",
    },
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) => (v && v.length == 11) || "Should be 11 digits.",
    ],
  }),
  components: {
    
    TermsAndConditions,
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
    },
  },

  created() {
    this.initialize();
  },
  mounted() {
    this.subscriptionPack = this.$route.params.subscription_pack;
  },
  beforeMount() {
    if (!this.$route.params.subscription_pack) {
      router.push("/subscription-package");
    }
  },

  methods: {
    initialize() {
      // console.log(this.$route.params);
      this.subscriptionPack = this.$route.params.subscription_pack;
    },
    showTermsAndConditions() {
      this.dialog2 = true;
    },
    save(date) {
      this.$refs.menu.save(date);
      this.menu1 = false;
    },

    onImageChange(file) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          // convert image file to base64 string
          let str = reader.result;
          let res = str.split(",");
          this.editedItem.transaction_photo = res[1];
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    chequeImageUpload(file) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          // convert image file to base64 string
          let str = reader.result;
          let res = str.split(",");
          this.editedItem.cheque_photo = res[1];
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    chequeDepositSlipUpload(file) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          // convert image file to base64 string
          let str = reader.result;
          let res = str.split(",");
          this.editedItem.deposit_slip_photo = res[1];
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    paymentGateway() {
      // console.log(this.subscriptionPack);
      
        this.$store.dispatch("storePayment", [
          "port-wallet-payment",
          this.subscriptionPack,
        ]);
        // this.clicked = true
      // }
    },
    bkash() {
      if (
        this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
      ) {
        alert(
          "You cannot pay greater than " +
            this.indexData.datas.total_budget_amount
        );
      } else if (
        this.editedItem.paid_amount < this.indexData.datas.payable_amount
      ) {
        alert(
          "You cannot pay less than " + this.indexData.datas.payable_amount
        );
      } else if (
        this.editedItem.paid_amount == null ||
        this.editedItem.paid_amount == undefined
      ) {
        alert("Pay minimum 10");
      } else {
        this.payment_method_id = 1;
        this.editedItem.payment_method_id = 1;
        this.editedItem.payment_status_id = 1;
        this.dialog = true;
      }
    },
    nagad() {
      if (
        this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
      ) {
        alert(
          "You cannot pay greater than " +
            this.indexData.datas.total_budget_amount
        );
      } else if (
        this.editedItem.paid_amount < this.indexData.datas.payable_amount
      ) {
        alert(
          "You cannot pay less than " + this.indexData.datas.payable_amount
        );
      } else if (
        this.editedItem.paid_amount == null ||
        this.editedItem.paid_amount == undefined
      ) {
        alert("Pay minimum 10");
      } else {
        this.payment_method_id = 2;
        this.editedItem.payment_method_id = 2;
        this.editedItem.payment_status_id = 1;
        this.dialog = true;
      }
    },
    cheque() {
      if (
        this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
      ) {
        alert(
          "You cannot pay greater than " +
            this.indexData.datas.total_budget_amount
        );
      } else if (
        this.editedItem.paid_amount < this.indexData.datas.payable_amount
      ) {
        alert(
          "You cannot pay less than " + this.indexData.datas.payable_amount
        );
      } else if (
        this.editedItem.paid_amount == null ||
        this.editedItem.paid_amount == undefined
      ) {
        alert("Pay minimum 10");
      } else {
        this.payment_method_id = 3;
        this.editedItem.payment_method_id = 3;
        this.editedItem.payment_status_id = 1;
        this.dialog = true;
      }
    },
    beftn() {
      if (
        this.editedItem.paid_amount > this.indexData.datas.total_budget_amount
      ) {
        alert(
          "You cannot pay greater than " +
            this.indexData.datas.total_budget_amount
        );
      } else if (
        this.editedItem.paid_amount < this.indexData.datas.payable_amount
      ) {
        alert(
          "You cannot pay less than " + this.indexData.datas.payable_amount
        );
      } else if (
        this.editedItem.paid_amount == null ||
        this.editedItem.paid_amount == undefined
      ) {
        alert("Pay minimum 10");
      } else {
        this.payment_method_id = 4;
        this.editedItem.payment_method_id = 4;
        this.editedItem.payment_status_id = 1;
        this.dialog = true;
      }
    },
    back() {
      router.push("/subscription-package");
    },
    submit() {
      if (this.$refs.form.validate()) {
        // console.log(this.editedItem)
        this.$store.dispatch("newTransaction", [
          "transaction",
          this.editedItem,
        ]);
        this.clicked = true;
      }
    },
    close() {
      this.dialog = false;
      this.payment_method_id = null;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.pay-button {
  font-size: 16px;
  background: #1565c0;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
